/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for any purpose without the express written permission of Honeywell. */
import { Avatar, Box, IconButton, LinearProgress } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import EditIcon from "@mui/icons-material/Edit";
import DefaultProfilePic from "../../images/addLogo.png";
import { Button } from "@forge/common";
import "./UploadProfilePic.scss";

interface IProps {
  previewImage?: any;
  onImageUpload?: (image: any) => void;
  profilePic?: string;
  isUploadDisabled?: boolean;
  labelText?: string;
  className?: string;
}

const UploadProfilePic = (props: IProps) => {
  const [imageSrc, setImageSrc] = useState<any>(DefaultProfilePic);
  const [previewImage, setPreviewImage] = useState<string>("");
  const logoLabelText = props?.labelText || "Add Photo";

  const fileInputRef = useRef<HTMLInputElement>(null);

  const selectImage = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files as FileList;
    const file = files?.[0];
    var allowedExtensions = /(\.jpg|\.jpeg|\.png|\.svg)$/i;
    const maxFileSize = 5 * 1024 * 1024; // 5 MB
    if (file) {
      if (!allowedExtensions.exec(files?.[0].name)) {
        alert("Invalid Logo file format, please select a Image file");
        return false;
      }
      if (file.size > maxFileSize) {
        alert("Invalid Logo file size, please select a file less than 5 MB");
        setPreviewImage("");
        return;
      }

      const selectedFiles = event.target.files as FileList;
      setPreviewImage(URL.createObjectURL(selectedFiles?.[0]));
      props.onImageUpload && props.onImageUpload(selectedFiles?.[0]);
    }
  };

  /**Set Profile Pic src if user has already profile pic */
  useEffect(() => {
    props.profilePic && setImageSrc(props.profilePic);
  }, []);

  useEffect(() => {
    !previewImage && props.profilePic && setImageSrc(props.profilePic);
  }, [props.profilePic]);

  /**If user uploads a image, update the same in state */
  useEffect(() => {
    previewImage && setImageSrc(previewImage);
  }, [previewImage]);

  const handleIconClick = () => {
    fileInputRef.current?.click();
  };

  return (
    <div
      className={`form_logo_wrap text-center color-bg-img ${
        props.isUploadDisabled ? "disabled-box p-20" : ""
      } upload-profile-pic-container-${props.className}`}
    >
      <div
        className={`form_logo_image color-bg-profile-img-wrapper ${
          props.isUploadDisabled ? "disabled-background" : ""
        } upload-profile-pic-wrapper-${props.className}`}
      >
        <img src={imageSrc} alt="Logo" className="" />
      </div>
      {!props.isUploadDisabled && (
        <div>
          <Button size="regular" variant="secondary" onClick={handleIconClick}>
            {logoLabelText}
          </Button>
          <input
            type="file"
            accept="image/*"
            ref={fileInputRef}
            data-testid="file-input"
            onChange={selectImage}
            style={{ display: "none" }}
          />
        </div>
      )}
    </div>
  );
};

export default UploadProfilePic;
